import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class MachineConnectedToWall extends DestroyableObstacle {
	static key = "MachineConnectedToWall";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): MachineConnectedToWall {
		const m = new MachineConnectedToWall(deserializeXY(data.xy));
		m.restoreBaseFields(data);
		return m;
	}
}
